<mat-dialog-content>
  @if(isStyleNormal()) {
  <div class="mat-dialog-content modal__window"
       [ngClass]="{'modal__window--message': isMessage, 'modal__window--error': isError}">

    <div class="box__heading box__heading--arrow">
      @if(data?.title){
      <h3>{{data?.title | translate:data.params}}</h3>
      }
      <mat-icon matSuffix class="mat-icon material-icons modal__window--close"
                (click)="close()">close</mat-icon>
    </div>

    @if(data) {
    <div class="modal__window--content" *ngIf="data">
      @if(data?.text){
      <div class="modal__window--subheader">
        {{data?.text | translate:data.params}}
      </div>
      }
    </div>
    }

    <div class="form__actions">
      <div class="form__buttons">

        @if(data?.noButton) {
        <button class="btn btn__secondary"
                type="submit"
                (click)="onSecondarySelected()"
                tabindex="0">
          {{data?.noButton | translate:data.params}}
        </button>
        }

        <button class="btn btn__primary"
                type="submit"
                (click)="onPrimarySelected()"
                tabindex="0">
          {{data?.yesButton | translate:data.params}}
        </button>

      </div>
    </div>
  </div>
  }

  @if(isStyleComplex()) {
  <div class="mat-dialog-content modal__window"
       [ngClass]="{'modal__window--message': isMessage, 'modal__window--error': isError}">

    <div class="box__headingcomplex box__headingcomplex--arrow">
      @if(data?.title){
      <h3>{{data?.title | translate:data.params}}</h3>
      }
      <mat-icon matSuffix class="mat-icon material-icons modal__window--close"
                (click)="close()">close</mat-icon>
    </div>

    <div class="modal__window--iconcontent">
      <img src="assets/images/icon__exclamation.svg" />
    </div>

    @if(data){
    <div class="modal__window--content">
      @if(data?.text){
      <div class="modal__window--complexcontent">
        {{data?.text | translate:data.params}}
      </div>
      }
    </div>

    <div class="modal__window--content">
      @if(data?.text2) {
      <div class="modal__window--complexcontent--bottomline">
        {{data?.text2 | translate:data.params}}
      </div>
      }
    </div>
    }

    <div class="form__buttons">

      <button class="btn btn__complex"
              type="submit"
              (click)="close(true)"
              tabindex="0">
        {{data?.yesButton | translate:data.params}}
      </button>

    </div>
  </div>
  }
</mat-dialog-content>
